export const checkIfLabelIsEnabled = (printConfig: string[], label: string) => {
  return printConfig.includes(label)
}
